import L from 'leaflet';
import transparentImg from '../../icons/transparent.png';
import { Marker, Tooltip } from 'react-leaflet';
import { StyledDeviceTotalTooltip } from '../../Styled';
import { useMapStore } from 'contexts/RootStore.context';
import { BuildingFeature } from 'types/venue';
import { useMemo } from 'react';

type UsersTotalCountProps = {
  buildingFeature: BuildingFeature;
};
export default function DevicesTotalCount({ buildingFeature }: UsersTotalCountProps) {

  const {
    selectedBuildingId,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    devices, // this should be here to force re-render on changes of users
    getBuidlingDevicesCount } = useMapStore()

  const displayPoint: any = [...buildingFeature.properties.display_point.coordinates].reverse(); // reversed to correct order
  const buildingIsSelected = buildingFeature.id === selectedBuildingId

  const customIcon = new L.Icon({
    iconUrl: transparentImg, // 1px alpha image to show nothing.
    iconSize: new L.Point(0, 0),
  });

  const devicesCount = useMemo(() => {
    return getBuidlingDevicesCount(buildingFeature.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [devices, devices.length])

  // only show tooltip if count is over 0 and building is not selected.
  if (devicesCount === 0 || buildingIsSelected) {
    return null
  }

  return (
    <Marker icon={customIcon} position={displayPoint}>
      <Tooltip
        className="tooltip-device-total"
        permanent
        opacity={1}
        direction="bottom"
        offset={[-40, 15]}
      >
        <StyledDeviceTotalTooltip id={`devices-total-count-${buildingFeature.id}`}>
          {devicesCount}
        </StyledDeviceTotalTooltip>
      </Tooltip>
    </Marker>
  )
}
